import { RootInitialState } from 'core/common/store/rootReducer';

export const getScanProcessingStatus = (state: RootInitialState) => {
  return state.scan.processingStatus;
};
